import api from '../configs/ConfigCmsApi';
import Cookies from 'js-cookie';
const options = () => ({ headers: { Authorization: Cookies.get('adminToken') } });
const path = id => `/offers/questionnaire-flows/${id}`;
export default {
  getQuestion: id => api.get(`/offers/questionnaire-questions/${id}`, options()),
  get: id => api.get(path(id), options()),
  save: (id, revision, draft) => api.put(path(id), { revision, draft }, options()),
  action: (id, action, data) => api.post(`${path(id)}/${action}`, { ...data, ...(action === 'publish' ? { confirm: 'PUBLISH_QUESTIONNAIRE_FLOW' } : action === 'archive' ? { confirm: 'ARCHIVE_QUESTIONNAIRE_FLOW' } : {}) }, options()),
};
